import * as React from 'react';
export const p24Svg = React.forwardRef(function p24SvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.28 14.213-.155.773H8.569l.308-1.529c.172-.857.47-1.418.898-1.684.427-.265 1.355-.47 2.784-.613 1.142-.11 1.85-.261 2.12-.452.273-.19.488-.683.648-1.48.14-.699.102-1.152-.117-1.36-.219-.208-.765-.313-1.641-.313-1.094 0-1.8.085-2.12.254-.322.168-.547.574-.675 1.216l-.11.607H9.658l.092-.422c.195-.972.555-1.62 1.08-1.943.526-.323 1.48-.485 2.862-.485 1.226 0 2.017.175 2.369.523.352.35.426 1.03.223 2.041-.195.972-.521 1.622-.98 1.949-.46.326-1.359.548-2.698.663-1.176.103-1.894.246-2.153.428-.26.183-.474.7-.645 1.553l-.055.274zm8.623-7.333-1.1 5.473h1.362l-.156.773h-1.36L22.271 15h-1.025l.376-1.874H16.53l.215-1.076 5.573-5.17h1.587zm-2.126 5.473.981-4.884h-.02l-5.208 4.884zM0 14.97l1.656-8.189h4.269c1.051 0 1.733.178 2.043.534.31.356.367 1.022.17 1.998-.19.936-.518 1.574-.985 1.913-.467.34-1.25.51-2.346.51l-.411.006H1.705l-.653 3.228zm1.862-4.007h2.493c1.042 0 1.73-.094 2.062-.282.332-.188.566-.62.702-1.296.16-.792.163-1.293.007-1.503-.156-.21-.604-.315-1.347-.315l-.401-.006H2.55zM6.142 3.8 5.13 3.166c1.193-.54 2.437-.98 3.717-1.311l.186.865c-.915.246-1.88.598-2.89 1.081zm11.481-.475a11.28 11.28 0 0 0-2.991-.948L15.449 1h.023c2.362.01 4.24.291 5.72.683l-3.569 1.644zM4.21 3.61l1.034.662c-.471.257-.953.541-1.443.857H1.793s.83-.698 2.415-1.519zm10.026-2.563-.484 1.221a13.034 13.034 0 0 0-4.016.25l-.138-.874c1.52-.34 3.074-.54 4.638-.598zm8.84 1.234c2.139.889 2.924 1.9 2.924 1.9h-6.92s-.228-.187-.659-.448z',
      fillRule: 'evenodd',
    }),
  );
});
p24Svg.defaultProps = {
  height: '16',
  viewBox: '0 0 26 16',
  width: '26',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var p24 = {
  category: 'paymentmethod',
  colorable: true,
  name: 'p24',
  svg: p24Svg,
};
